import { useAppContext } from "utils/context";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  createUserAddress,
  getCitiesData,
  getProvincesData,
  getUserAddress,
} from "containers/services/services";

import {
  handleStagesBankMetrix,
  handleAddressData,
  provinceDataTransformer,
} from "containers/services/data.transformers";

import AddButton from "./components/addButton";
import AddressList from "./components/list";
import AddressModal from "./components/modal";
import Header from "./components/header";
import SubmitButton from "./components/submitButton";

const BankAddress = ({ loading, currentStage, onFinishAddress }) => {
  const formRef = useRef();
  const { instance, metrixInstance } = useAppContext();
  const [addressList, setAddressList] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [address, setAddress] = useState(null);
  const [loadingList, setLoadingList] = useState(false);
  const [open, setOpen] = useState(false);
  const [loadingAddress, setLoadingAddress] = useState(false);

  const getProvinces = useCallback(async () => {
    const response = await getProvincesData(instance);
    if (response) {
      setProvinces(response?.data);
    }
  }, [instance]);

  useEffect(() => {
    getProvinces();
  }, [getProvinces]);

  const getCities = async (e) => {
    const response = await getCitiesData(instance, e);
    if (response) {
      setCities(response?.cities);
    }
  };

  const getAddresses = useCallback(async () => {
    setLoadingList(true);
    const response = await getUserAddress(instance);
    if (response) {
      setAddressList(response?.addresses);
      setAddress(response?.addresses[response?.addresses?.length - 1]?.id || 1);
    }
    setLoadingList(false);
  }, [instance]);

  useEffect(() => {
    getAddresses();
  }, [getAddresses]);

  const onChangeAddress = (e) => {
    setAddress(e.target.value);
  };

  const onFinishAddAddress = async (values) => {
    setLoadingAddress(true);

    const { data } = await createUserAddress(
      instance,
      handleAddressData(values)
    );
    if (data) {
      await getAddresses();
    }
    setOpen(false);
    setLoadingAddress(false);
  };

  const handleDrawer = (value) => {
    setOpen(value);
  };

  const handleAddressValue = () => {
    const params = { address_id: address };
    return onFinishAddress(params);
  };

  useMemo(async () => {
    await handleStagesBankMetrix("ADDRESS", metrixInstance);
  }, [currentStage?.key]);

  return (
    <div className="  pt-12">
      <Header />
      <AddressList
        addressList={addressList}
        address={address}
        onChangeAddress={onChangeAddress}
        loading={loadingList}
      />
      <AddButton onClick={handleDrawer} />
      <SubmitButton
        loading={loading}
        disabled={addressList?.length === 0}
        onClick={handleAddressValue}
      />
      <AddressModal
        handleDrawer={handleDrawer}
        open={open}
        loading={loadingAddress}
        onFinishAddAddress={onFinishAddAddress}
        formRef={formRef}
        provinces={provinceDataTransformer(provinces)}
        cities={provinceDataTransformer(cities)}
        getCities={getCities}
      />
    </div>
  );
};
export default BankAddress;
